import { defineStore } from "pinia";
import { $axios } from "@bloglovin/vue-framework";

const POLL_INTERVAL_MS = 3000;

export const useDevboxStore = defineStore("devbox-store", {
  state: () => ({
    creating: false,
    currentDevboxName: "",
    log: "",
    running: false,
    done: false,
    pollIntervalId: null,
    lastError: "",
  }),
  actions: {
    createAiWorkflowDevbox(devboxName) {
      if (this.creating) {
        return;
      }
      this.creating = true;
      this.currentDevboxName = devboxName;
      this.log = "";
      this.running = false;
      this.done = false;
      this.lastError = "";
      $axios.post("/devbox/create", {
        devbox_name: devboxName,
      }).then(response => {
        if (response.data.success) {
          this.running = true;
          this.startPolling();
        } else {
          this.creating = false;
          this.lastError = "Server reported create failed.";
        }
      }).catch(err => {
        this.creating = false;
        this.lastError = err?.message || "Request failed.";
      });
    },
    startPolling() {
      this.stopPolling();
      this.fetchStatus();
      this.pollIntervalId = setInterval(() => this.fetchStatus(), POLL_INTERVAL_MS);
    },
    stopPolling() {
      if (this.pollIntervalId) {
        clearInterval(this.pollIntervalId);
        this.pollIntervalId = null;
      }
    },
    killDevboxCreate() {
      if (!this.currentDevboxName) {
        return;
      }
      $axios.post(`/devbox/${this.currentDevboxName}/kill`)
          .then(() => {
            this.fetchStatus();
          })
          .catch(err => {
            this.lastError = err?.message || "Kill request failed.";
          });
    },
    fetchStatus() {
      if (!this.currentDevboxName) {
        return;
      }
      $axios.get(`/devbox/${this.currentDevboxName}/status`)
          .then(response => {
            this.log = response.data.log;
            this.running = !!response.data.running;
            this.done = !!response.data.done;
            if (!this.running) {
              this.creating = false;
              this.stopPolling();
            }
          })
          .catch(err => {
            this.lastError = err?.message || "Status fetch failed.";
          });
    },
  },
});
